<template>
    <div class="app-container">
      <el-dialog
        :visible="visible"
        :width="width"
        append-to-body
        modal
        @close="handleCloes"
      >
        <BjDivider>{{ $t('screenWMS.detail') }}</BjDivider>
        <BjPage
          ref="BjPageTop"
          :get-action="queryApiTop"
          :query-params="queryParamsTop"
          :col-span="colSpan"
          :search-btn-span="colSpan"
          :serial="serial"
          :search-btn-hide="true"
          :before-reset-search="beforeResetSearch"
          :height="217"
          @afterFetchOriginalData="afterFetchOriginalData"
        >
          <template v-slot:tableColumn>
            <template v-for="(col, index) in labelListTop">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
                <template slot-scope="scope">
                  <template v-if="false" />
                  <template v-else-if="col.prop === 'dataStatus'">
                    {{ $t(IMPORT_STATUS.bjGet(scope.row.dataStatus)) }}
                  </template>
                  <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                </template>
              </el-table-column>
            </template>
          </template>
        </BjPage>

        <BjDivider>{{ $t('screenWMS.log') }}</BjDivider>
        <BjPage
          ref="BjPageBottom"
          :get-action="queryApiBottom"
          :query-params="queryParamsBottom"
          :col-span="colSpan"
          :search-btn-span="colSpan"
          :serial="serial"
          :search-btn-hide="true"
          :before-reset-search="beforeResetSearch"
          :height="217"
          @afterFetchOriginalData="afterFetchOriginalData"
          style="margin-bottom: 20px;"
        >
          <template v-slot:tableColumn>
            <template v-for="(col, index) in labelListBottom">
              <el-table-column v-if="col.prop !== 'bjTableAction'" :key="`col_${index}_${col.prop}_${col.width || 'auto'}`" :prop="col.prop" :label="col.label" :width="col.width || 'auto'" :fixed="col.fixed || false" align="center" class-name="item" :show-overflow-tooltip="col.prop !== 'bjTableAction'">
                <template slot-scope="scope">
                  <template v-if="false" />
                  <template v-else-if="col.prop === 'dataStatus'">
                    {{ $t(IMPORT_STATUS.bjGet(scope.row.dataStatus)) }}
                  </template>
                  <span v-else>{{ scope.row[col.prop] | timeFilters(scope.row[col.prop]) }}</span>
                </template>
              </el-table-column>
            </template>
          </template>
        </BjPage>
      </el-dialog>
    </div>
  </template>
  <script>
  import pageMiXin from '@/utils/page-mixin.js';
  import { waveApi } from '@/api';
  export default {
    name: 'History',
    mixins: [pageMiXin],
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      width: {
        type: String,
        default: '50%',
      },
    },
    data() {
      return {
        colSpan: 8,
        queryApiTop: waveApi.getWaveViewTop,
        queryApiBottom: waveApi.getWaveHistory,
        // 查询参数
        queryParamsTop: {},
        queryParamsBottom: {},
        labelListTop: [
          { label: 'SKU', prop: 'skuCode', isCheck: true, disabled: false,},
          { label: this.$t('screenWMS.printPickQty'), prop: 'pickQty', isCheck: true, disabled: false,},
          { label: this.$t('screenWMS.printPickTotal'), prop: 'totalItemQty', isCheck: true, disabled: false,},
        ],
        labelListBottom: [
          { label: 'SKU', prop: 'skuCode', isCheck: true, disabled: false,},
          { label: this.$t('screenWMS.scan'), prop: 'scanTime', isCheck: true, disabled: false,},
          { label: this.$t('screenWMS.Creator'), prop: 'creationBy', isCheck: true, disabled: false,},
        ],
      };
    },
    watch: {
      visible: {
        handler(v) {
          if (v) {
           this.$nextTick(() => {
             this.$refs.BjPageTop.onSearch();
             this.$refs.BjPageBottom.onSearch();
           });
        }
        }
      },
    },
    methods: {
      // 过滤页面数据
      afterFetchOriginalData(data) {
        data.content = data.records
        return data;
      },
      beforeResetSearch() {
        this.queryParams.waveId = null;
        return new Promise(resolve => {
          resolve();
        });
      },
      handleCloes() {
        this.$emit('close');
      },
    }
  };
  </script>
  